import { render, staticRenderFns } from "./ProductInvite.html?vue&type=template&id=704effe6&scoped=true&"
import script from "./ProductInvite.vue?vue&type=script&lang=ts&"
export * from "./ProductInvite.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInvite.scss?vue&type=style&index=0&id=704effe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704effe6",
  null
  
)

export default component.exports